import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const SnippetModalWrapper = styled.div`
  .input {
    height: 48px;
    max-width: 600px;
    width: 100%;
    background-color: ${colors.grey6};
    padding: 12px;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    border: none;
    border-radius: 8px;

    &::placeholder {
      font-family: Poppins;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }

    &:focus {
      outline: none;
    }

    &--shrinked {
      width: max-content;
    }

    &--textarea {
      resize: none;
      min-height: 48px;
      overflow: hidden;
      box-sizing: border-box;
    }
  }
  .snippet-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    width: 524px;
    max-height: 576px;
    padding: 48px 48px 42px 48px;
    background-color: ${colors.white};
    border-radius: 16px;
    overflow: hidden;
    box-sizing: border-box;

    &__name {
      margin: 4px 0 24px;
      height: 24px;
      border: none;
      border-bottom: 1px solid ${colors.grey444};

      &:focus {
        outline: none;
      }
    }

    &__text-area {
      resize: none;
      height: fit-content;
      max-height: 200px;
    }
    &__user-based-box {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: start;
      margin-top: 32px;
      .left-part {
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 4px;
        .title-container {
          display: flex;
          align-items: center;
          gap: 8px;
          .icon-information {
            cursor: pointer;
            :hover > path {
              stroke: ${colors.primaryDark};
            }
          }
        }
      }
    }
  }
`;
